module.exports = __webpack_public_path__ + "static/schulz-and-peanuts-d6ec1644cb81f5351c6ea7d2780d28d7.jpg";